/* global o_tracking */

window.o_global = window.o_global || {};

/**
 * M-Pathy API-JS File. Here you can find functions for M-Pathy to deal with OTTO-Features.
 */
o_global.mpathy = o_global.mpathy || (function (win) {
    "use strict";

    /**
     * Api-Function for M-Pathy to send Mpathy Visitor ID (vid) and M-Pathy Page-ID (pid) to Comscore via bct-Call.
     *
     * @param {String} vid      M-Pathy VisitorID.
     * @param {String} pid      M-Pathy PageID.
     */
    function trackToComscore(vid, pid) {
        if (typeof (vid) === "string" && typeof (pid) === "string") {
            var trackObj = {
                "ot_MpathyVid": vid,
                "ot_MpathyPageId": pid
            };

            // Call send-Function
            if (!!o_tracking && !!o_tracking.bct && !!o_tracking.bct.sendMergeToTrackingServer && typeof(o_tracking.bct.sendMergeToTrackingServer) === "function") {
                o_tracking.bct.sendMergeToTrackingServer(trackObj);
            }
        }
    }

    /**
     * Check if mPathy should be enabled.
     * Extend the tests array to add new tests.
     *
     * @example in shopoffice: if (mpathySwitch === 'on' && o_global.mpathy.isEnabled())
     *
     * @return {Boolean} Returns true if ONE of the tests returns TRUE and _isDisabled() is false.
     */
    function isEnabled() {
        // Array with test functions.
        var tests = [
            _isBreakpointGreaterThanM,
            _deviceTest
        ];

        if (!o_util.toggle.get("EMR_MPATHY", true) || o_util.misc.isPreview(win.location.href)) {
            return false;
        }

        return _runTests(true, tests);
    }

    /**
     * Run the tests for isEnabled()
     *
     * @private
     *
     * @param {Boolean} result      To return true/false on first true/false test.
     * @param {Array} tests         Functions to run.
     *
     * @return {Boolean} Result if its first test or not
     */
    function _runTests(result, tests) {
        while (tests.length) {
            if (tests.shift().call() === result) {
                return result;
            }
        }

        return !result;
    }

    /**
     * Check for breakpoint > M in cookie.
     *
     * @private
     *
     * @return {Boolean} Value if breakpoint is greater than M
     */
    function _isBreakpointGreaterThanM() {
        return o_global.device.breakpoint.getCurrentBreakpoint() !== "s" && o_global.device.breakpoint.getCurrentBreakpoint() !== "m";
    }

    /**
     * Check if the client is visiting the page with a specific device.
     *
     * @private
     *
     * @return {Boolean} Value if the user uses a specific device
     */
    function _deviceTest() {
        /**
         * Check the user agent to detect Galaxy S5, S5 mini, S6, S6 Edge, S7.
         *
         * @see http://user-agents.me/device/samsung-galaxy-s5
         *
         * @private
         *
         * @return {Boolean} Value if device is strong Samsung Galaxy
         */
        function _isStrongSamsungGalaxy() {
            var models = [
                "SAMSUNG SM-G900F",     // S5
                "SM-G900P",             // S5
                "SAMSUNG SM-G900H",     // S5
                "SAMSUNG SM-G900T",     // S5
                "SM-G900F",             // S5
                "SM-G900H",             // S5
                "SCL23",                // S5
                "SAMSUNG SM-G900FQ",    // S5
                "SM-G900T",             // S5
                "SM-G900V",             // S5
                "SM-G900M",             // S5
                "SC-04F",               // S5
                "SAMSUNG SM-G900I",     // S5
                "SM-G920F",             // S6
                "SM-G920I",             // S6
                "SM-G9200",             // S6
                "SM-G925F",             // S6 Edge
                "SM-G800F",             // S5 mini
                "SM-G930F"              // S7
            ];

            for (var i in models) {
                if (models.hasOwnProperty(i) && !!navigator.userAgent.match(models[i])) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Check the user agent for "iPhone" and the screen size to detect the iPhone 6.
         * Unfortunately there is no other way to detect the iPhone model/version.
         *
         * @private
         *
         * @return {Boolean} Value if device is iphone 6
         */
        function _isIPhone6() {
            return !!navigator.userAgent.match("iPhone") && ((window.screen.height === 667 && window.screen.width === 375) || (window.screen.width === 667 && window.screen.height === 375));
        }

        return (_isStrongSamsungGalaxy() || _isIPhone6()) && _connectionTypeTest();
    }

    /**
     * Check for the experimental navigator.connection.type feature.
     * Return false if available and the user is not in the wifi.
     *
     * @private
     *
     * @return {Boolean} Value if the test could be ran or not
     */
    function _connectionTypeTest() {
        var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

        // Connection api not supported: pass the test
        if (!connection) {
            return true;
        }

        // Pass only if user connected to wifi or '2' in case of Galaxy S5 with stockbrowser
        return (connection.type === "wifi") || (parseInt(connection.type, 10) === 2);
    }

    return {
        "trackToComscore": trackToComscore,
        "isEnabled": isEnabled
    };
}(window));
